/** GitHub's logo URL. Kept separate from `github-ai`'s registration so the MCP
 * server spec can use it without registering the integration. */
export const GithubAiIconUrl =
  "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png";
